import React, {useRef} from 'react';
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import TextField from "../../../../components/FormElements/TextField";
import PageHeader from "../../../../components/PageHeader";
import QuestionTooltip from "../../../../components/QuestionTooltip";
import { useBonusTagForm } from "../../hooks/useBonusTagForm";
import styles from './profileBonusTags.module.scss';
import Modal from "../../../../portals/Modal";
import {PhoneInputField} from "../../../../components/PhoneInput";
import ButtonOutlined from "../../../../components/FormElements/ButtonOutlined";
import {Badge, BadgeTag, BadgeTagSmall} from "../../../../components/Badge";
import EditTagModal from "../../../../components/EditTagModal";
import Checkbox from "../../../../components/FormElements/Checkbox";

const showIcon = (
  <svg width="25" height="20" viewBox="0 0 25 20" fill="currentColor">
      <path d="M8.61719 4.42188C8.30017 4.42188 7.99614 4.54781 7.77197 4.77197C7.54781 4.99614 7.42188 5.30017 7.42188 5.61719V14.3828C7.42188 14.6998 7.54781 15.0039 7.77197 15.228C7.99614 15.4522 8.30017 15.5781 8.61719 15.5781H17.3828C17.6998 15.5781 18.0039 15.4522 18.228 15.228C18.4522 15.0039 18.5781 14.6998 18.5781 14.3828V11.7266C18.5781 11.5504 18.6481 11.3815 18.7726 11.257C18.8972 11.1325 19.0661 11.0625 19.2422 11.0625C19.4183 11.0625 19.5872 11.1325 19.7118 11.257C19.8363 11.3815 19.9062 11.5504 19.9062 11.7266V14.3828C19.9062 15.0521 19.6404 15.6939 19.1672 16.1672C18.6939 16.6404 18.0521 16.9062 17.3828 16.9062H8.61719C7.94793 16.9062 7.30608 16.6404 6.83285 16.1672C6.35961 15.6939 6.09375 15.0521 6.09375 14.3828V5.61719C6.09375 4.94793 6.35961 4.30608 6.83285 3.83285C7.30608 3.35961 7.94793 3.09375 8.61719 3.09375H11.2734C11.4496 3.09375 11.6185 3.16371 11.743 3.28825C11.8675 3.41279 11.9375 3.58169 11.9375 3.75781C11.9375 3.93393 11.8675 4.10284 11.743 4.22738C11.6185 4.35191 11.4496 4.42188 11.2734 4.42188H8.61719ZM14.0625 3.75781C14.0625 3.39125 14.36 3.09375 14.7266 3.09375H19.2422C19.6088 3.09375 19.9062 3.39125 19.9062 3.75781V8.27344C19.9062 8.44956 19.8363 8.61846 19.7118 8.743C19.5872 8.86754 19.4183 8.9375 19.2422 8.9375C19.0661 8.9375 18.8972 8.86754 18.7726 8.743C18.6481 8.61846 18.5781 8.44956 18.5781 8.27344V5.36112L15.1962 8.74306C15.1345 8.80473 15.0613 8.85366 14.9807 8.88703C14.9001 8.92041 14.8138 8.93759 14.7266 8.93759C14.6393 8.93759 14.553 8.92041 14.4724 8.88703C14.3918 8.85366 14.3186 8.80473 14.2569 8.74306C14.1953 8.68139 14.1463 8.60818 14.113 8.5276C14.0796 8.44702 14.0624 8.36065 14.0624 8.27344C14.0624 8.18622 14.0796 8.09986 14.113 8.01928C14.1463 7.9387 14.1953 7.86548 14.2569 7.80381L17.6389 4.42188H14.7266C14.36 4.42188 14.0625 4.12437 14.0625 3.75781Z" fill="currentColor"/>
  </svg>
)
const penIcon = (
  <svg width="25" height="20" viewBox="0 0 25 20" fill="currentColor">
      <path d="M10.8753 16.4141C10.7365 16.5529 10.5114 16.5529 10.3725 16.4141L7.2455 13.2878C7.10661 13.1489 7.10661 12.9238 7.2455 12.7849L15.5222 4.51013C15.661 4.37131 15.8861 4.37131 16.025 4.51013L19.152 7.63643C19.2909 7.77529 19.2909 8.00046 19.152 8.13932L10.8753 16.4141ZM6.47287 14.2215C6.5564 13.9707 6.87465 13.8955 7.06158 14.0824L9.57744 16.5977C9.76441 16.7846 9.68922 17.1029 9.43837 17.1865L5.6664 18.4423C5.3885 18.5348 5.12419 18.2705 5.21675 17.9926L6.47287 14.2215ZM20.52 6.77646L20.1418 7.1546C20.0029 7.29342 19.7778 7.29342 19.639 7.1546L16.5071 4.0235C16.3683 3.88464 16.3683 3.65947 16.5071 3.52061L16.8853 3.14259C17.5195 2.50813 18.548 2.50813 19.1822 3.14259L20.52 4.48008C21.1496 5.11627 21.1496 6.14047 20.52 6.77646Z" fill="currentColor"/>
  </svg>
)
const trashIcon = (
  <svg width="13" height="16" viewBox="0 0 13 16" fill="currentColor">
      <path d="M8.4375 2.375H11.25C11.8125 2.375 12.1875 2.75 12.1875 3.3125V4.25H0V3.3125C0 2.75 0.46875 2.375 0.9375 2.375H3.75C3.9375 1.34375 4.96875 0.5 6.09375 0.5C7.21875 0.5 8.25 1.34375 8.4375 2.375ZM4.6875 2.375H7.5C7.3125 1.8125 6.65625 1.4375 6.09375 1.4375C5.53125 1.4375 4.875 1.8125 4.6875 2.375ZM0.9375 5.1875H11.25L10.4062 14.6562C10.4062 15.125 9.9375 15.5 9.46875 15.5H2.71875C2.25 15.5 1.875 15.125 1.78125 14.6562L0.9375 5.1875Z" fill="currentColor"/>
  </svg>
)

const XLSIcon = (
  <svg style={{ flexShrink: 0 }} width="30" height="30" viewBox="0 0 30 30" fill="none">
    <path d="M18.2888 24.375C18.2888 24.6236 18.19 24.8621 18.0142 25.0379C17.8384 25.2137 17.5999 25.3125 17.3513 25.3125H14.07C13.8214 25.3125 13.583 25.2137 13.4071 25.0379C13.2313 24.8621 13.1325 24.6236 13.1325 24.375V17.8125C13.1325 17.5639 13.2313 17.3254 13.4071 17.1496C13.583 16.9738 13.8214 16.875 14.07 16.875C14.3187 16.875 14.5571 16.9738 14.733 17.1496C14.9088 17.3254 15.0075 17.5639 15.0075 17.8125V23.4375H17.3513C17.5999 23.4375 17.8384 23.5363 18.0142 23.7121C18.19 23.8879 18.2888 24.1264 18.2888 24.375ZM10.865 17.0496C10.7648 16.978 10.6515 16.9269 10.5315 16.8991C10.4116 16.8714 10.2874 16.8675 10.1659 16.8877C10.0445 16.908 9.92821 16.9519 9.82376 17.0171C9.71931 17.0823 9.62872 17.1674 9.55716 17.2676L7.9763 19.4813L6.39544 17.2676C6.32643 17.1614 6.23662 17.0703 6.13144 16.9998C6.02625 16.9293 5.90787 16.8808 5.78343 16.8573C5.659 16.8338 5.53109 16.8357 5.40742 16.863C5.28376 16.8903 5.1669 16.9423 5.06391 17.016C4.96091 17.0897 4.87391 17.1835 4.80816 17.2917C4.7424 17.3999 4.69926 17.5203 4.68132 17.6457C4.66339 17.7711 4.67104 17.8988 4.70381 18.0211C4.73658 18.1434 4.7938 18.2578 4.872 18.3574L6.82435 21.0938L4.86966 23.8301C4.73811 24.0325 4.68971 24.2778 4.73452 24.515C4.77934 24.7522 4.91393 24.963 5.11026 25.1034C5.30659 25.2439 5.54953 25.3032 5.78849 25.269C6.02745 25.2348 6.24402 25.1098 6.3931 24.9199L7.9763 22.7062L9.55716 24.9199C9.70623 25.1098 9.9228 25.2348 10.1618 25.269C10.4007 25.3032 10.6437 25.2439 10.84 25.1034C11.0363 24.963 11.1709 24.7522 11.2157 24.515C11.2606 24.2778 11.2121 24.0325 11.0806 23.8301L9.12825 21.0938L11.0829 18.3574C11.1545 18.2572 11.2056 18.1439 11.2334 18.024C11.2612 17.9041 11.2651 17.7798 11.2448 17.6584C11.2246 17.5369 11.1806 17.4207 11.1154 17.3162C11.0503 17.2118 10.9652 17.1212 10.865 17.0496ZM22.4595 20.0754C21.9908 19.9395 21.5056 19.8 21.2349 19.6254C21.0884 19.5293 21.0908 19.5082 21.1036 19.4027C21.1054 19.3175 21.1276 19.234 21.1684 19.1591C21.2092 19.0843 21.2674 19.0203 21.338 18.9727C21.8771 18.607 23.1357 18.7711 23.6607 18.907C23.9012 18.9703 24.1571 18.9354 24.3719 18.81C24.5867 18.6846 24.7429 18.479 24.8062 18.2385C24.8694 17.9979 24.8345 17.7421 24.7091 17.5273C24.5838 17.3124 24.3782 17.1562 24.1376 17.093C23.8904 17.0285 21.6767 16.4812 20.2904 17.4164C19.998 17.6139 19.7526 17.8732 19.5714 18.1759C19.3902 18.4786 19.2776 18.8174 19.2415 19.1684C19.0072 21.0293 20.8411 21.5602 21.9368 21.8766C23.3501 22.2855 23.4743 22.4531 23.4345 22.766C23.3982 23.0484 23.2868 23.1562 23.1825 23.2266C22.6435 23.5852 21.406 23.4082 20.8927 23.2676C20.6526 23.2009 20.3959 23.2324 20.179 23.355C20.0716 23.4157 19.9772 23.497 19.9012 23.5942C19.8252 23.6914 19.7691 23.8026 19.7361 23.9215C19.7031 24.0404 19.6938 24.1646 19.7088 24.2871C19.7238 24.4095 19.7627 24.5278 19.8235 24.6352C19.9461 24.8521 20.1499 25.0115 20.39 25.0781C20.971 25.2312 21.5692 25.31 22.17 25.3125C22.8521 25.3125 23.6115 25.1953 24.2197 24.7898C24.5197 24.5903 24.7718 24.3268 24.9578 24.0182C25.1438 23.7096 25.2591 23.3636 25.2954 23.0051C25.5544 20.9766 23.6185 20.4105 22.4595 20.0754ZM4.69505 13.125V4.6875C4.69505 4.19022 4.89259 3.71331 5.24422 3.36167C5.59585 3.01004 6.07277 2.8125 6.57005 2.8125H17.82C17.9432 2.8124 18.0652 2.83657 18.179 2.88362C18.2928 2.93067 18.3962 2.99969 18.4833 3.08672L25.0458 9.64922C25.1329 9.73635 25.2019 9.83977 25.2489 9.95358C25.296 10.0674 25.3201 10.1893 25.32 10.3125V13.125C25.32 13.3736 25.2213 13.6121 25.0455 13.7879C24.8696 13.9637 24.6312 14.0625 24.3825 14.0625C24.1339 14.0625 23.8955 13.9637 23.7196 13.7879C23.5438 13.6121 23.445 13.3736 23.445 13.125V11.25H17.82C17.5714 11.25 17.333 11.1512 17.1571 10.9754C16.9813 10.7996 16.8825 10.5611 16.8825 10.3125V4.6875H6.57005V13.125C6.57005 13.3736 6.47128 13.6121 6.29546 13.7879C6.11965 13.9637 5.88119 14.0625 5.63255 14.0625C5.38391 14.0625 5.14545 13.9637 4.96964 13.7879C4.79382 13.6121 4.69505 13.3736 4.69505 13.125ZM18.7575 9.375H22.1185L18.7575 6.01289V9.375Z" fill="#6C6D6C"/>
  </svg>
)

export default function BonusTags() {
  const fileInputRef = useRef(null)

  const handleButtonClick = () => {
    fileInputRef.current?.click(); // триггерим клик на input
  };

  const {
    formik,
    info,
    pending,
    crossPending,
    errorModal,
    setErrorModal,
    error,
    phone,
    setPhone,
    t,
    deletingTag,
    setDeleteTagId,
    deleteTagId,
    handleAddPhone,
    handleDeleteTag,
    handleLoadFiles,
    setTagId,
    history,
    tagId,
  } = useBonusTagForm();


  return (
      <>
          <PageHeader title={t('NSTag.tags')}>
              <div    >
                  <QuestionTooltip text={t('NSTag.tags')} />
              </div>
          </PageHeader>
          <div className={styles.container}>
              <form onSubmit={formik.handleSubmit}>
                <div className={styles.block}>
                    <div style={{ maxWidth: 650 }}>
                        <TextField
                          label={t('NSPromocode.comeUpWithAName')}
                          value={formik.values.title}
                          placeholder={t("corporative")}
                          error={false}
                          required
                          onChange={(e) => formik.setFieldValue('title', e.target.value)}
                        />
                    </div>
                </div>

                {formik.values.title && (
                  <BadgeTag
                    style={{
                    ...(formik.values.backgroundColor ? {backgroundColor: formik.values.backgroundColor} : {}),
                    ...(formik.values.color ? {color: formik.values.color} : {}),
                    }}
                  >
                    {formik.values.title}
                  </BadgeTag>
                )}

                <div className={styles.block}>
                  <div>
                    <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 }}>
                      <label>Выберите цвет текста</label>
                      <input type="color" value={formik.values.color} name="color" onChange={formik.handleChange} />
                    </div>
                    <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                      <label>Выберите фоновый цвет</label>
                      <input type="color" value={formik.values.backgroundColor} name="backgroundColor" onChange={formik.handleChange} />
                    </div>
                  </div>
                </div>

                  <div className={styles.block}>
                      <div style={{ maxWidth: 300 }}>
                          <TextField
                            label={t('NSTag.bonusPrecent')}
                            type="number"
                            required
                            placeholder={12}
                            value={formik.values.bonusPercentage}
                            onChange={(e) => formik.setFieldValue('bonusPercentage', e.target.value)}
                          />
                      </div>
                  </div>

                  <div className={styles.block}>
                      <Checkbox
                        label={t('NSTag.isDiscount') || 'Is Discount'}
                        checked={formik.values.isDiscount}
                        onChange={(e) => formik.setFieldValue('isDiscount', e.target.checked)}
                      />
                  </div>

                  <div className={styles.block} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                      <p style={{ margin: 0 }}>{t('NSTag.addPhones')}</p>

                      {formik.values.phoneNumbers.length > 0 && (
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                            {formik.values.phoneNumbers.map((phone) => (
                              <Badge key={phone}>
                                  +{phone}
                              </Badge>
                            ))}
                        </div>
                      )}
                      <div style={{ display: 'flex', gap: 12 }}>
                          <PhoneInputField
                            inputStyle={{ height: 46 }}
                            containerStyle={{ width: 300 }}
                            enableSearch={false}
                            disableDropdown={true}
                            size="large"
                            value={phone}
                            onChange={setPhone}
                          />

                          <ButtonOutlined variant="green" onClick={handleAddPhone}>{t('add')}</ButtonOutlined>
                      </div>
                  </div>

                <div className={styles.block}>
                  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    {formik.values.file && (
                      <Badge>
                        {XLSIcon}
                        <span style={{ color: '#6C6D6C', fontSize: 18, overflowWrap: 'anywhere' }}>{formik.values.file.name}</span>
                      </Badge>
                    )}
                  </div>
                </div>
                <div className={styles.block} onClick={handleButtonClick}>
                  <ButtonOutlined variant="green">
                    <input
                      type="file"
                      accept=".xlsx,.xls"
                      // multiple
                      onChange={(e) => {
                        const file = e.target.files[0];
                        handleLoadFiles(file)
                      }}
                      ref={fileInputRef}
                      hidden
                    />
                    {t('importFile')}
                  </ButtonOutlined>
                </div>


                  <div className={styles.footer}>
                      <ButtonFilled disabled={error} type="submit" loading={pending || crossPending}>{t('save')}</ButtonFilled>
                  </div>
              </form>
          </div>

        {info?.configuration?.tags?.length > 0 && (
          <div
            style={{
              marginTop: 20,
            }}
          >
            <h2
              style={{
                fontFamily: 'graphic',
                color: '#1D1F23',
                marginBottom: 20,
                fontWeight: '500',
                fontSize: '18px',
                margin: '0 15px 0 0',
                borderBottom: '1px solid #E4E7EB',
                paddingBottom: 21,
              }}
            >
              {t('NSTag.tags')}
            </h2>


            <table className="table" style={{ width: '100%' }}>
              <thead>
              <tr>
                <th>
                  №
                </th>
                <th>
                  {t('NSTag.tagName')}
                </th>
                <th>
                  {t('NSTag.bonusPrecent')}
                </th>
                <th>
                  {t('NSTag.type')}
                </th>
                <th>
                  {t('NSTag.userCount')}
                </th>
                <th>
                  {t('action')}
                </th>
              </tr>
              </thead>
              <tbody>
              {info?.configuration?.tags?.map((tag, index) => (
                <tr key={tag.id}>
                  <td>{index + 1}</td>
                  <td>
                    <BadgeTagSmall
                      style={{
                        ...(tag.background_color ? {backgroundColor: tag.background_color} : {}),
                        ...(tag.color ? {color: tag.color} : {}),
                      }}
                    >
                      {tag.name}
                    </BadgeTagSmall>
                  </td>
                  <td>{tag.bonus_percentage}%</td>
                  <td>{tag.is_discount ? t('NSTag.discount') : t('NSTag.bonus')}</td>
                  <td>{tag.user_count}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                      <button className={styles.actionBtn} onClick={() => history.push(`/tag/${tag.id}`)}>
                        {showIcon}
                      </button>
                      <button className={styles.actionBtn} onClick={() => setTagId(tag.id)}>
                        {penIcon}
                      </button>
                      <button className={styles.actionDeleteBtn} onClick={() => setDeleteTagId(tag.id)}>
                        {trashIcon}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>
        )}

        <Modal
          open={errorModal} size="small"
          onClickClose={() => setErrorModal(false)}>
            <div className={styles.modal}>
                <p>
                    {t('optionForbidden')} <br/>
                    {t('touchModerator')}
                </p>
                <div>
                    <ButtonFilled
                      loading={pending}
                      onClick={() => setErrorModal(false)}
                    >{t('close')}</ButtonFilled>
                </div>
            </div>
        </Modal>

        <Modal
          open={!!deleteTagId}
          size="medium"
          onClickClose={() => setDeleteTagId('')}
        >
          <div className={styles.modal} style={{ width: '100%', maxWidth: '550px' }}>
            <p>
              Вы действительно хотите текущую запись? <br/>
              После удаление, невозможно возвращать <br/> запись. История заказов связано с записями <br/> будет сохранится.
            </p>
            <div style={{ display: 'flex', gap: 43, marginTop: 53, alignItems: 'center', justifyContent: 'center' }}>
              <div>
                <ButtonFilled loading={deletingTag} variant="red" onClick={() => !deletingTag && handleDeleteTag(deleteTagId)}>
                  Удалить
                </ButtonFilled>
              </div>
              <div>
                <ButtonFilled variant="gray" onClick={() => setDeleteTagId('')}>
                  Отменить
                </ButtonFilled>
              </div>
            </div>
          </div>
        </Modal>

        <EditTagModal
          tagId={tagId}
          setModal={setTagId}
        />
      </>
  )
}
